/**
 * Tiny DOM helpers shared by all components.
 * Keeps each component file small and consistent.
 */

/**
 * Create a detached DOM node from an HTML template string.
 * Returns the first element child so components can append it directly.
 *
 * @param {string} html
 * @returns {HTMLElement}
 */
export function fromTemplate(html) {
  const tpl = document.createElement('template');
  tpl.innerHTML = html.trim();
  const node = tpl.content.firstElementChild;
  if (!node) {
    throw new Error('fromTemplate: template produced no element');
  }
  return /** @type {HTMLElement} */ (node);
}

/**
 * Mount a component (anything with a `render()` method that returns an element)
 * into a parent element.
 *
 * @param {HTMLElement} parent
 * @param {{ render: () => HTMLElement }} component
 */
export function mount(parent, component) {
  parent.appendChild(component.render());
}
